'use strict';

var windowDefined = typeof window !== 'undefined';
var environment = windowDefined ? 'browser' : 'server';

module.exports = {
  environment: environment,
  isServer: environment === 'server',
  isBrowser: environment === 'browser'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/core/environment.js
// module id = 3A3p
// module chunks = 88